import type { UserAdditionalLinkResponse } from '../types.d';
import type { UserAdditionalLink } from '../entities';

export default function userAdditionalLinkSerializer(
  data: UserAdditionalLinkResponse,
): UserAdditionalLink {
  return {
    type: data.type,
    link: data.link,
  };
}
